import React, { useState } from "react";

import { Link } from "react-router-dom";

// reactstrap
import { DropdownToggle } from "reactstrap";

// Import menuDropdown
import LanguageDropdown from "../../Components/Common/LanguageDropdown";
import ProfileMenu from "../../Components/CommonForBoth/TopBarDropDown/ProfileMenu";

import logo from "../../assets/images/logo/pappermap-logo-wordmark.png";

// import logoLight from "../../assets/images/logo-light.png";
// import logoLightSvg from "../../assets/images/logo-light.svg";
// import logoDark from "../../assets/images/logo-dark.png";

//i18n
import { withTranslation } from "react-i18next";
import BranchDropdown from "Components/Common/Branch/BranchDropdown";
import { useSelector } from "react-redux";
import { RootState } from "slices";

const Header = (props: any) => {
  // const [menu, setMenu] = useState<any>(false);
  const [isSearch, setSearch] = useState<any>(false);
  // const [socialDrp, setsocialDrp] = useState<any>(false);
  const cart = useSelector((state: RootState) => state.cart.items);

  // function toggleFullscreen() {
  //   let document: any = window.document;
  //   if (
  //     !document.fullscreenElement &&
  //     /* alternative standard method */ !document.mozFullScreenElement &&
  //     !document.webkitFullscreenElement
  //   ) {
  //     // current working methods
  //     if (document.documentElement.requestFullscreen) {
  //       document.documentElement.requestFullscreen();
  //     } else if (document.documentElement.mozRequestFullScreen) {
  //       document.documentElement.mozRequestFullScreen();
  //     } else if (document.documentElement.webkitRequestFullscreen) {
  //       document.documentElement
  //         .webkitRequestFullscreen
  //         //   Element.ALLOW_KEYBOARD_INPUT
  //         ();
  //     }
  //   } else {
  //     if (document.cancelFullScreen) {
  //       document.cancelFullScreen();
  //     } else if (document.mozCancelFullScreen) {
  //       document.mozCancelFullScreen();
  //     } else if (document.webkitCancelFullScreen) {
  //       document.webkitCancelFullScreen();
  //     }
  //   }
  // }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="40px" />
                </span>
                <span className="logo-lg">
                  <img src={logo} alt="" height="40px" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logo} alt="" height="40px" />
                </span>
                <span className="logo-lg">
                  <img src={logo} alt="" height="40px" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 d-lg-none header-item"
              data-toggle="collapse"
              onClick={props.toggleLeftmenu}
              data-target="#topnav-menu-content"
            >
              <i className="fa fa-fw fa-bars" />
            </button>

            <form className="app-search d-none d-lg-block">
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
          </div>

          <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
                onClick={() => setSearch(!isSearch)}
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  isSearch
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={props.t("Search") + "..."}
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <LanguageDropdown />

            <DropdownToggle
              className="btn header-item noti-icon position-relative"
              tag="button"
              disabled
              id="page-header-notifications-dropdown"
            >
              <i className="bx bx-cart" />
              <span className="badge bg-danger rounded-pill">
                {cart.length}
              </span>
            </DropdownToggle>

            {/* <NotificationDropdown /> */}

            <BranchDropdown />
            <ProfileMenu toggleCanvas={props.toggleCanvas} />
            {/* 
            <div className="dropdown d-inline-block">
              <button
                onClick={props.toggleCanvas}
                type="button"
                className="btn header-item noti-icon right-bar-toggle "
              >
                <i className="bx bx-cog bx-spin" />
              </button>
            </div> */}
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default withTranslation()(Header);
